import React from "react";
import "../mapeDokumentacijaItem/flowSymbols.css";

// Zajednička logika simbola dijagrama toka — koriste je ekran procedure
// (mapeDokumentacijaItem) i štampa mape procesa (printMapaProcesa), da bi
// oblici u štampi/PDF-u bili identični onima na ekranu.
export const SYMBOL_TYPES = [
  { value: "", label: "-" },
  { value: "start", label: "Početak" },
  { value: "activity", label: "Aktivnost" },
  { value: "control", label: "Kontrola" },
  { value: "decision", label: "Odluka" },
  { value: "end", label: "Kraj" },
];

const LEGACY_SYMBOL_MAP = {
  oval: "start",
  rectangle: "activity",
  "rounded-rect": "control",
  triangle: "control",
  line: "control",
  diamond: "decision",
};

export function normalizeSymbolType(type) {
  const normalizedRaw = (type || "").toString().trim().toLowerCase();
  if (
    !normalizedRaw ||
    normalizedRaw === "null" ||
    normalizedRaw === "none" ||
    normalizedRaw === "undefined" ||
    normalizedRaw === "-"
  ) {
    return "";
  }
  return LEGACY_SYMBOL_MAP[normalizedRaw] || normalizedRaw;
}

export default function FlowSymbol({
  type,
  text,
  showTypeLabel = false,
  showConnector = false,
}) {
  const normalizedType = normalizeSymbolType(type);
  if (!normalizedType) {
    if (showTypeLabel) return null;
    return (
      <div className="flow-symbol-container">
        <div className="flow-symbol-plain-text">{text || ""}</div>
      </div>
    );
  }

  const symbolClass = `flow-symbol flow-symbol-${normalizedType}`;
  const typeLabel =
    SYMBOL_TYPES.find((s) => s.value === normalizedType)?.label || "";
  const symbolText = showTypeLabel ? typeLabel : text || typeLabel;

  return (
    <div className="flow-symbol-container" style={{ flexDirection: "column" }}>
      <div className={symbolClass}>
        <span className="flow-symbol-text">{symbolText}</span>
      </div>
      {showConnector && (
        <div className="flow-connector">
          <div className="flow-connector-line"></div>
          <div className="flow-connector-arrow"></div>
        </div>
      )}
    </div>
  );
}
